export default __webpack_public_path__ + "static/ACRA-Practitioner-Member-43381f99688f43dd51a25c20de4bc600.png";